import { render, staticRenderFns } from "./AuthorizationRuleAssignmentForm.vue?vue&type=template&id=35fb1258&"
import script from "./AuthorizationRuleAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRuleAssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationRuleAssignmentForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports